<template lang="pug">
Response(
    view="default"
    title="Эта ссылка на оплату больше не работает"
    description="Пожалуйста, проверьте правильность введённой ссылки или запросите новую"
    :error-code="errorCode"
)
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { sendAppEventWithRetry } from '@/packages/namba-metrics'

import { Response } from '@/shared/ui/Response'
import { useAppStore } from '@/shared/model'

const errorCode = generateRandomNumber()

function generateRandomNumber() {
    return (Math.floor(Math.random() * 9000000000) + 1000000000).toString()
}

export default defineComponent({
    name: 'ExpiredLinkState',

    setup() {
        const { state } = useAppStore()

        sendAppEventWithRetry({
            name: 'screenWithId',
            type: state.kind === 'expired' ? 'expired' : 'exception',
            id: errorCode,
        })

        return {
            errorCode,
        }
    },
    components: { Response },
})
</script>
